import React from "react";
import classes from "./AsttButton.module.css";

const styles = (theme) => ({
  button: {
    ":disabled": {
      backgroundColor: "grey",
    },
  },
});

const AsttButton = (props) => {
  return (
    <button
      className={`${props.buttonClass} ${classes.button}`}
      disabled={props.disabled}
      onClick={props.onClick}
      type={props.type || "button"}
      title={props.title}
    >
      {props.children}
    </button>
  );
};

export default AsttButton;
